import { FormControlLabel, GKDataGrid, Switch } from "components";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { EMPLOYEE_ACCESS_ID_BY_CLIENT } from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { clientAccessColumn } from "utils/columns";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import useDocumentTitle from "utils/useDocumentTitle";

const AdminAccess = () => {
  useDocumentTitle("Admin Access");
  const { id } = useParams();

  const [clientList, setClientList]: any = useState([]);

  const [switchLoading, setSwitchLoading] = useState("");

  const [selectedClientList, setSelectedClientList] = useState([]);

  const requestBody = useGenerateQueryParams("employeeClientAccess");

  const { isFetching, refetch, isRefetching } = useFetchQuery({
    key: [QueryKeys.CLIENT_ACCESS, requestBody],
    route: EMPLOYEE_ACCESS_ID_BY_CLIENT(id),
    requestBody,
    success: (response: any) => {
      setClientList(response?.data);
      setSelectedClientList(response?.data?.clients);
    },
  });

  const { mutate: enableDisableCLient, isLoading: enableDisableCLientLoading } =
    useMutation({
      mutationFn: (arr: any) =>
        axiosInstance.patch(`/employees/access/${id}/clients/`, {
          clients: arr,
        }),
      onSuccess: () => {
        refetch();
        refetchQuery(QueryKeys.EMPLOYEE_ACCESS);
      },
    });

  return (
    <GKDataGrid
      columns={clientAccessColumn(
        enableDisableCLientLoading,
        isRefetching,
        isFetching,
        switchLoading,
        selectedClientList,
        setSwitchLoading,
        enableDisableCLient,
      )}
      rows={clientList?.data || []}
      loading={selectedClientList?.length === 0 && isFetching}
      headerComponent={
        <FormControlLabel
          control={
            <Switch
              checked={clientList?.enableAll}
              onChange={() => {
                axiosInstance
                  .patch(`/employees/access/${id}/all_clients/`)
                  .then(() => {
                    refetch();
                    refetchQuery(QueryKeys.EMPLOYEE_ACCESS);
                  })
                  .catch((error) => {
                    toast.error(
                      error?.response?.data?.message ||
                        "Something went wrong, please try again.",
                    );
                  });
              }}
            />
          }
          label={clientList?.enableAll ? "Disable All" : "Enable All"}
          labelPlacement="end"
        />
      }
      totalCount={clientList.totalCount || 0}
      name="employeeClientAccess"
      exportFile={{
        path: EMPLOYEE_ACCESS_ID_BY_CLIENT(id),
        exportName: "EmployeeToClientAccessList",
      }}
    />
  );
};

export default AdminAccess;
